import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';
import makeData from '../services/makeData';
import { COLUMNS } from '../config/Transaction/columns';

interface AsyncState {
  isLoading: {
    orderData: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  orderData: any;
  totalCount: Number;
  statusData: any;
  applicationOptions: any;
  addProductRes: any;
  editProductRes: any;
  deleteProductRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  brandsData: Array<any>;
  tagsData: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;
  userTableColumns: any,

}

const initialState: TableState = {
  isLoading: {
    orderData: true,
  },
  isSuccess: false,
  isError: false,
  orderData: null,
  statusData: null,
  applicationOptions: null,
  addProductRes: null,
  editProductRes: null,
  deleteProductRes: null,
  totalCount: NaN,
  isLogout: false,
  fullResponse: [],
  brandsData: [],
  tagsData: [],
  errorMsg: null,
  userTableColumns: COLUMNS,
};




export const fetchAllOrders = createAsyncThunk('orderData', async (data: any, thunkAPI) => {
  try {
    const res: any = await Service.getOrders(data);

    const madeData = makeData(res.data);

    return { madeData, fullResponse: res.data };
  } catch (error: any) {
    // thunkAPI.dispatch(resetLogout(error))
    return thunkAPI.rejectWithValue(error);
  }
});


export const getColumns = createAsyncThunk('getColumns', (data: any, thunkAPI) => {
  try {
    // const madeColsData = makeData(data);
    return data?.cols;
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});


export const categorySlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchAllOrders.pending, (state, action: any) => {
        state.isLoading.orderData = true;
        state.isError = false;
        state.errorMsg = null;
      })
      .addCase(fetchAllOrders.fulfilled, (state, action: any) => {
        state.isLoading.orderData = false;
        state.isSuccess = true;
        state.isError = false;
        state.orderData = action.payload.madeData;
        state.fullResponse = action.payload.fullResponse;
        state.errorMsg = null;
      })
      .addCase(fetchAllOrders.rejected, (state, action: any) => {
        state.isLoading.orderData = false;
        state.isError = true;
        state.errorMsg = action.payload.errorMsg;
        state = {
          ...state,
          ...action.payload
        }

      })
      // MODIFY_COLUMNS
      .addCase(getColumns.pending, (state) => {
        // state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.userTableColumns = initialState.userTableColumns;
      })
      .addCase(getColumns.fulfilled, (state, action: any) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.userTableColumns = action.payload;
      })
      .addCase(getColumns.rejected, (state) => {
        // state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.userTableColumns = initialState.userTableColumns;
      })

      


  },
});

export default categorySlice.reducer;
